<template>
  <div>
    <div v-if="is_disable_by_date">
      <v-icon icon="mdi-alert" color="red-darken-4"></v-icon>Le PPS est valable 3 mois. Vous pourrez réaliser votre PPS
      à partir du {{ date_validite_pps }} et revenir indiquer le numéro d'attestation PPS dans votre fiche
      d'inscription. Un mail
      automatique de relance vous sera envoyé.
    </div>
    <a v-if="!is_disable_by_date" href="https://pps.athle.fr/" target="_blank"><v-btn color="primary-dark"
        variant="elevated" elevation="0" size="small">Faire mon PPS</v-btn></a>
    <label class="field_label">{{ current_champ.label }}<span class="text-red"
        v-if="current_champ.mandatory == 1">*</span>
      <v-btn class="ml-1" density="compact" color="primary-dark" variant="elevated" elevation="0"
        icon="mdi-information-variant" rounded @click="dialog_info_pps = true"></v-btn></label>
    <div class="text-subtitle-2"
      v-if="mainStore.module && (mainStore.module.base == 'VVX26' || mainStore.module.base == 'VVX27')">
      L'organisation rappelle que le trail constitue un effort important et conséquent. Il est donc vivement conseillé
      aux personnes présentant des pathologies cardiaques ou respiratoires de consulter un médecin avant de participer à
      l’événement.
    </div>
    <v-text-field v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="current_champ.disabled || is_disable || is_disable_by_date" :hint="get_hint"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode, is_ffa)]"></v-text-field>

    <v-dialog v-model="dialog_response_webservice_success" max-width="400px">
      <v-card class="pa-2">
        <v-card-title>Pass Prévention Santé</v-card-title>
        <v-card-text><v-icon icon="mdi-check" color="green-darken-4"></v-icon> Votre numéro de PPS a été validé par la
          FFA</v-card-text>
        <v-card-actions>
          <v-btn color="primary-dark" text @click="dialog_response_webservice_success = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_response_webservice_error" max-width="400px">
      <v-card class="pa-2">
        <v-card-title>Pass Prévention Santé</v-card-title>
        <v-card-text>
          <div class="text-red-darken-4"><v-icon icon="mdi-alert"></v-icon> <b>{{ webservice_readable_error }}</b></div>
          <v-divider class="my-2"></v-divider>
          <div><b>Nom:</b> {{ inscription.coureur.champs.nom.value }}</div>
          <div><b>Prénom:</b> {{ inscription.coureur.champs.prenom.value }}</div>
          <div><b>Sexe:</b> {{ inscription.coureur.champs.sexe.value }}</div>
          <div><b>Date de naissance:</b> {{ get_french_date(inscription.coureur.champs.date_naissance.value) }}</div>
          <div><b>Numéro de PPS:</b> {{ last_pps_value }}</div>
          <div v-if="show_additional_field_error" class="text-subtitle-2 mt-2">
            D'autres informations semblent également incorrectes. Seule la correction du {{
              locked_correction_field_label }} est autorisée ici. Veuillez contacter le support Sportips.
          </div>
          <div v-if="show_identity_correction_form && !show_additional_field_error" class="mt-4">
            <v-divider class="my-2"></v-divider>
            <div class="text-subtitle-2 mb-2">Corrigez le champ indiqué pour qu'il corresponde à votre attestation PPS :
            </div>
            <v-text-field v-if="locked_correction_field == 'nom'" v-model="identity_correction_value" label="Nom"
              hide-details="auto"></v-text-field>
            <v-text-field v-else-if="locked_correction_field == 'prenom'" v-model="identity_correction_value"
              label="Prénom" hide-details="auto"></v-text-field>
            <v-select v-else-if="locked_correction_field == 'sexe'" v-model="identity_correction_value"
              :items="sexe_items" label="Sexe" hide-details="auto"></v-select>
            <div v-else-if="locked_correction_field == 'date_naissance'" class="d-flex ga-2">
              <v-text-field label="Jour" type="number" placeholder="JJ" v-model="readable_date.day" min="1" max="31"
                hide-details="auto"></v-text-field>
              <v-text-field label="Mois" type="number" placeholder="MM" v-model="readable_date.month" min="1" max="12"
                hide-details="auto"></v-text-field>
              <v-text-field label="Année" type="number" placeholder="AAAA" v-model="readable_date.year" min="1900"
                max="2100" hide-details="auto"></v-text-field>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn v-if="show_identity_correction_form && !show_additional_field_error" color="primary-dark"
            variant="elevated" elevation="0" :loading="is_retrying_pps"
            @click="retry_pps_with_identity_correction">Corriger et revérifier</v-btn>
          <v-spacer v-if="show_identity_correction_form"></v-spacer>
          <v-btn color="darkblue" text @click="close_error_dialog">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_info_pps" width="500" max-width="100%" scroll-strategy="none">
      <v-card>
        <v-card-text>
          <PPSMessage :with_image="true"></PPSMessage>
        </v-card-text>
        <v-card-actions>
          <v-btn class="ms-auto" text="Fermer" @click="dialog_info_pps = false">Fermer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import PPSMessage from "@/components/Home/PPS_Message.vue";
export default {
  components: { PPSMessage },
  props: {
    champ: { type: Object, required: true },
    inscription: { type: Object, required: true },
    mode: { type: String, default: null },
    is_disable: { type: Boolean, default: false },
    allow_identity_correction: { type: Boolean, default: false },
  },
  data() {
    return {
      last_field_change: null,
      last_pps_value: null,
      webservice_readable_error: "",
      dialog_response_webservice_success: false,
      dialog_response_webservice_error: false,
      current_champ: {},
      snackbar_success: false,
      snackbar_error: false,
      dialog_info_pps: false,
      is_first_run: true,
      locked_correction_field: null,
      detected_wrong_field: null,
      original_locked_field_value: null,
      original_inscription_field_value: null,
      identity_correction_value: "",
      pending_identity_correction: null,
      is_correcting_identity: false,
      is_retrying_pps: false,
      readable_date: { day: "", month: "", year: "" },
    };
  },
  watch: {
    champ: {
      deep: true,
      handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
      },
    },
    "current_champ.value": {
      async handler() {
        if (this.is_first_run) {
          this.is_first_run = false;
          return;
        }
        if (this.is_correcting_identity) return;
        this.verify_pps_on_webservice();
      },
    },
    "inscription.coureur.champs.nom": {
      deep: true,
      async handler() {
        if (this.is_correcting_identity) return;
        this.verify_pps_on_webservice("nom");
      },
    },
    "inscription.coureur.champs.prenom": {
      deep: true,
      async handler() {
        if (this.is_correcting_identity) return;
        this.verify_pps_on_webservice("prénom");
      },
    },
    "inscription.coureur.champs.sexe": {
      deep: true,
      async handler() {
        if (this.is_correcting_identity) return;
        this.verify_pps_on_webservice("sexe");
      },
    },
    "inscription.coureur.champs.date_naissance": {
      deep: true,
      async handler() {
        if (this.is_correcting_identity) return;
        this.verify_pps_on_webservice("date de naissance");
      },
    },
    dialog_response_webservice_error(isOpen) {
      if (!isOpen) {
        this.handle_error_dialog_closed();
      }
    },
  },
  computed: {
    ...mapStores(useMainStore),
    is_ffa() {
      return this.mainStore.module.is_ffa_module;
    },
    show_identity_correction_form() {
      return this.allow_identity_correction && this.locked_correction_field;
    },
    show_additional_field_error() {
      return this.show_identity_correction_form
        && this.detected_wrong_field
        && this.detected_wrong_field !== this.locked_correction_field;
    },
    locked_correction_field_label() {
      const labels = {
        nom: "nom",
        prenom: "prénom",
        sexe: "sexe",
        date_naissance: "date de naissance",
      };
      return labels[this.locked_correction_field] || this.locked_correction_field;
    },
    sexe_items() {
      return this.$itemsSelect.sexe();
    },
    date_validite_pps() {
      let date_fin = this.mainStore.module.evenement.date_fin;
      return this.$moment(date_fin).subtract(12, "months").format("DD/MM/YYYY");
    },
    is_disable_by_date() {
      let date_fin = this.mainStore.module.evenement.date_fin;
      return this.$moment(date_fin).diff(this.$moment(), "months") >= 12;
    },
    get_hint() {
      if (this.current_champ.nom == "numero_pps") {
        return "Accepté : Numéro de PPS (11 caractères)";
      }
      return "";
    },
  },
  methods: {
    get_french_date(date) {
      return this.$moment(date).format("DD/MM/YYYY");
    },
    close_error_dialog() {
      this.dialog_response_webservice_error = false;
    },
    snapshot_locked_field_value(field) {
      const coureur_champ = this.inscription.coureur.champs[field];
      this.original_locked_field_value = coureur_champ ? coureur_champ.value : "";
      if (Object.prototype.hasOwnProperty.call(this.inscription, field)) {
        this.original_inscription_field_value = this.inscription[field];
      }
    },
    revert_identity_corrections() {
      if (!this.locked_correction_field || this.original_locked_field_value === null) {
        return;
      }
      if (typeof this.inscription.revert_pps_identity_correction === "function") {
        this.inscription.revert_pps_identity_correction(
          this.locked_correction_field,
          this.original_locked_field_value,
          this.original_inscription_field_value
        );
        return;
      }
      this.apply_identity_correction_to_coureur(this.locked_correction_field, this.original_locked_field_value);
    },
    reset_correction_state() {
      this.locked_correction_field = null;
      this.detected_wrong_field = null;
      this.pending_identity_correction = null;
      this.original_locked_field_value = null;
      this.original_inscription_field_value = null;
      this.identity_correction_value = "";
      this.readable_date = { day: "", month: "", year: "" };
    },
    handle_error_dialog_closed() {
      this.revert_identity_corrections();
      this.reset_correction_state();
    },
    lock_correction_field(field) {
      if (!this.allow_identity_correction || !field) {
        return;
      }
      if (!this.locked_correction_field) {
        this.locked_correction_field = field;
        this.snapshot_locked_field_value(field);
      }
    },
    init_identity_correction_value() {
      if (!this.locked_correction_field || !this.inscription.coureur.champs[this.locked_correction_field]) return;
      const value = this.inscription.coureur.champs[this.locked_correction_field].value;
      this.identity_correction_value = value;
      if (this.locked_correction_field === "date_naissance" && value) {
        const date = value.split("-");
        this.readable_date = { day: date[2] || "", month: date[1] || "", year: date[0] || "" };
      }
    },
    get_identity_correction_value() {
      if (this.locked_correction_field === "date_naissance") {
        const day = this.readable_date.day;
        const month = this.readable_date.month;
        const year = this.readable_date.year;
        if (parseInt(day) > 0 && parseInt(day) < 32 && parseInt(month) > 0 && parseInt(month) < 13 && parseInt(year) > 1900 && parseInt(year) < 2100) {
          return `${year}-${month}-${day}`;
        }
        return "";
      }
      return this.identity_correction_value;
    },
    apply_identity_correction_to_coureur(field, value) {
      const coureur = this.inscription.coureur;
      if (coureur.champs[field]) {
        coureur.champs[field].value = value;
      }
    },
    async retry_pps_with_identity_correction() {
      const corrected_value = this.get_identity_correction_value();
      if (!corrected_value) {
        this.mainStore.notification.send("Veuillez renseigner une valeur valide pour corriger votre inscription.", "error", 4000);
        return;
      }
      this.is_retrying_pps = true;
      this.is_correcting_identity = true;
      this.pending_identity_correction = { field: this.locked_correction_field, value: corrected_value };
      this.apply_identity_correction_to_coureur(this.locked_correction_field, corrected_value);
      this.current_champ.value = this.last_pps_value;
      await this.verify_pps_on_webservice();
      this.is_correcting_identity = false;
      this.is_retrying_pps = false;
    },
    async verify_pps_on_webservice(field_change = null) {
      this.last_field_change = field_change;
      this.inscription.coureur.unvalidate_document();
      let disable_webservice = this.mainStore.module.disable_webservice_ffa;
      let num_ffa = this.mainStore.module.ffa_num_competition;
      if (disable_webservice || !num_ffa || num_ffa == "" || !this.current_champ.is_valid_num_pps() || this.is_disable_by_date) {
        return;
      }
      let response = await this.inscription.coureur.try_fetch_pps_webservice(num_ffa);
      if (response) {
        if (response.valid_ffa) {
          if (this.pending_identity_correction && this.allow_identity_correction && typeof this.inscription.set_pps_identity_correction === "function") {
            this.inscription.set_pps_identity_correction(this.pending_identity_correction.field, this.pending_identity_correction.value);
            this.pending_identity_correction = null;
          }
          this.original_locked_field_value = null;
          this.original_inscription_field_value = null;
          this.dialog_response_webservice_error = false;
          this.dialog_response_webservice_success = true;
          this.$emit("pps_validated");
        } else {
          this.pending_identity_correction = null;
          this.last_pps_value = this.current_champ.value || this.last_pps_value;
          this.detected_wrong_field = this.parse_wrong_field(response.message);
          this.webservice_readable_error = this.get_readable_error(response.message, this.detected_wrong_field);
          this.lock_correction_field(this.detected_wrong_field);
          if (this.allow_identity_correction && this.locked_correction_field) {
            this.init_identity_correction_value();
          }
          this.dialog_response_webservice_error = true;
          this.current_champ.value = "";
        }
      }
    },
    parse_wrong_field(error) {
      if (error.includes("LE NOM NE CORRESPOND PAS")) return "nom";
      if (error.includes("LE PRENOM NE CORRESPOND PAS")) return "prenom";
      if (error.includes("LA DATE DE NAISSANCE NE CORRESPOND PAS")) return "date_naissance";
      if (error.includes("LE SEXE NE CORRESPOND PAS")) return "sexe";
      return null;
    },
    get_readable_error(error, wrong_field = null) {
      if (error == "numero_pps manquant") return "Le numéro PPS est manquant ou incorrect";
      if (error == "id_inscription manquant" || error == "num_ffa manquant") return "Une erreur est survenue";
      if (error.includes("AU MOMENT DE LA COMPETITION")) return "Votre numéro de PPS est trop ancien pour cet évenement";
      if (error.includes("IDENTITE DIFFERENTE")) return "Les informations de votre PPS ne correspondent pas à vos informations d'inscription, veuillez vérifier que les informations renseignées soient STRICTEMENT identiques";
      if (error.includes("INTROUVABLE")) return "Le numéro de PPS renseigné n'existe pas, veuillez vérifier le numéro sur votre attestation.";
      if (wrong_field === "nom") {
        return "Le nom de famille renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
      }
      if (wrong_field === "prenom") {
        return "Le prénom renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
      }
      if (wrong_field === "date_naissance") {
        return "La date de naissance renseignée sur votre PPS ne correspond pas à celle renseigné pour votre inscription";
      }
      if (wrong_field === "sexe") {
        return "Le sexe renseigné sur votre PPS ne correspond pas à celui renseigné pour votre inscription";
      }
      return "Une erreur est survenue";
    },
  },
  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped></style>
